import { InfoIcon, RefreshCcwIcon } from 'lucide-react';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { InputFile } from 'src/components/inputs/InputFile';
import { Button } from 'src/components/ui/button';
import { Label } from 'src/components/ui/label';
import { Tooltip, TooltipTrigger } from 'src/components/ui/tooltip';

export function ConfigurationCriteriaProductsSkeleton(): ReactElement {
  const { t } = useTranslation('configuration');

  return (
    <div className='grid w-full max-w-sm items-center gap-3'>
      <Label
        className='cursor-not-allowed text-layout-foreground-secondary'
        htmlFor='products'
      >
        {t('Manual import of products')}
      </Label>
      <div className='flex items-center gap-2'>
        <InputFile
          accept='.csv'
          disabled
          id='products'
          onFileUpload={() => {}}
        />
        <Button className='px-2' disabled size='icon' variant='outline'>
          <RefreshCcwIcon className='size-4' />
        </Button>
        <Tooltip>
          <TooltipTrigger disabled>
            <InfoIcon className='size-4 text-layout-foreground-secondary' />
          </TooltipTrigger>
        </Tooltip>
      </div>
    </div>
  );
}
